<div class="modal-body">

  <div class="form-group">
    <label>Numéro de facture</label>
    <div class="input-group">
      <input 
        type="text" 
        class="form-control border-right-0" 
        [(ngModel)]="suppplierInvoiceNumber"
        [class.border-right-0]="suppplierInvoiceNumber != ''"
        (keyup)="searchInvoice()"
      />
      <div class="input-group-append" *ngIf="suppplierInvoiceNumber != '' && receptionInvoiceStatus">
        <span class="input-group-text bg-white border-left-0">
          <span *ngIf="!invoiceLoading && receptionInvoiceStatus.invoiceId == null">
            Facture inexistante
            <i class="bi bi-exclamation-circle text-warning"></i>
          </span>
          <span *ngIf="!invoiceLoading && receptionInvoiceStatus.invoiceId != null">
            Facture existante
            <i class="bi bi-check-circle text-success"></i>
          </span>
        </span>
      </div>
    </div>

    <div class="alert alert-warning mt-2" *ngIf="receptionInvoiceStatus && receptionInvoiceStatus.receptionEntries != null && receptionInvoiceStatus.receptionEntries.length > 0">
      Cette facture est associé aux réceptions:
      <ul>
        <li *ngFor="let entry of receptionInvoiceStatus.receptionEntries">
          <a [href]="'inventory/reception/' + entry.id" target="_blank" >
            {{ entry.receptionTimestamp }}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div class="form-group">
    <label >Fournisseur</label>
    <select-supplier (supplierChange)="supplierSelected($event)"></select-supplier>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modal.close()">Annuler</button>
  <button type="button" class="btn btn-primary" (click)="newReception()">Créer</button>
</div>